import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { from, Subscription } from 'rxjs';
import { DataService } from '../data/data.service';
import { FunctionsService } from '../functions/functions.service';
import { FcmService } from '../fcm/fcm.service';

const USER = 'user';
const ACCESS_TOKEN = 'accessToken';
const REFRESH_TOKEN = 'refreshToken';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private dataService: DataService,
    private functionService: FunctionsService,
    private storage: Storage,
    private navCtrl: NavController,
    private fcm:FcmService
  ) {}

  getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN);
  }

  async removeCredentials() {
    localStorage.removeItem(ACCESS_TOKEN);
    return await Promise.all([
      this.storage.remove(USER),
      this.storage.remove(REFRESH_TOKEN),
    ]);
  }

  getRefreshToken() {
    let promise = new Promise(async (resolve, reject) => {
      let token = await this.storage.get(REFRESH_TOKEN);
      this.dataService
        .getData('/user/refreshToken?token=' + token)
        .subscribe(
          (res: any) => {
            localStorage.setItem(ACCESS_TOKEN, res.accessToken);
            resolve(res.token);
          },
          (e) => reject(e)
        );
    });
    return from(promise);
  }


  login(body: any) {
    this.functionService.showLoading();
    this.dataService.postData('/user/login', body).subscribe(
      async (user: any) => {
        await this.storage.set(USER, user);
        await this.storage.set(REFRESH_TOKEN, user.refreshToken);
        localStorage.setItem(ACCESS_TOKEN, user.accessToken);
        this.functionService.dismissLoading();
        this.dataService.multi ? this.navCtrl.navigateForward('/complete-order')  : this.navCtrl.navigateForward('/welcome');
        this.fcm.subscriptionToUser()
      },
      (err) => {
        this.functionService.dismissLoading();
        if (err.status == 404)
          return this.functionService.presentToast(
            'خطأ باسم المستخدم او كلمة المرور'
          );

        if (err.status == 403)
          return this.functionService.presentToast(
            'لقد تم تعطيل حسابك برجاء التواصل مع الشركة'
          );
        return this.functionService.presentToast('خطأ بالشبكة');
      }
    );
  }



  async logOut() {
    this.functionService.showLoading();
    await this.fcm.unsubscribe();
    await this.removeCredentials();
    this.functionService.dismissLoading();
    // this.navCtrl.navigateRoot('/login');
  }

  async userStatus() {
    return new Promise((resolve) => {
      this.dataService.getData(`/status`).subscribe(async (res: any) => {
        if (res.active) {
          await this.storage.set('user', res?.user);
          resolve(true)
        }else{
          this.functionService.presentToast(res.message);
          this.logOut();
        }
      },err => {
        resolve(false)
      });
    })
  }
}
